import { PivotFilterOperatorEnum } from '@ztechapps/common.contract'

/** Whether a pivot filter operator ranks members — `top` and `bottom` — instead of testing a member against an operand. */
export const isPivotTopOrBottomOperator = (operator: PivotFilterOperatorEnum): boolean =>
  operator === PivotFilterOperatorEnum.top || operator === PivotFilterOperatorEnum.bottom
